import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreateMasterProduct = createModule({
  base: 'CREATE_MASTER_PRODUCT',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS, method: 'post' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Master Product created successfully',
});
const UpdateMasterProduct = createModule({
  base: 'UPDATE_MASTER_PRODUCT',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Master Product updated successfully',
});
const GetMasterProduct = createModule({
  base: 'GET_MASTER_PRODUCT',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS, method: 'get' },
});
const GetMasterProductById = createModule({
  base: 'GET_MASTER_PRODUCT_BY_ID',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS, method: 'get' },
});

const GetMasterProductVariants = createModule({
  base: 'GET_MASTER_PRODUCT_VARIANTS',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS_VARIANTS({}), method: 'get' },
});

const GetMasterProductVariantsByID = createModule({
  base: 'GET_MASTER_PRODUCT_VARIANTS_BY_ID',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS_VARIANTS({}), method: 'get' },
});

const AddMasterProductVariant = createModule({
  base: 'ADD_MASTER_PRODUCT_VARIANT',
  apiDetails: { ...SERVICE_ENDPOINT.MASTER_PRODUCTS_VARIANTS, method: 'post' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Master Product Variant created successfully',
});

export { CreateMasterProduct, GetMasterProduct, UpdateMasterProduct, GetMasterProductById, GetMasterProductVariants, GetMasterProductVariantsByID, AddMasterProductVariant };
